import { Star } from 'lucide-react';

export const Stars = ({ rating }) => {
  const r = Number(rating || 0);

  return (
    <div className="mbid-stars">
      {[1, 2, 3, 4, 5].map(s => (
        <Star
          key={s}
          size={13}
          fill={s <= r ? '#f59e0b' : '#e5e7eb'}
          color={s <= r ? '#f59e0b' : '#e5e7eb'}
        />
      ))}
    </div>
  );
};

export const StarPicker = ({ value, onChange }) => (
  <div className="mbid-star-picker">
    {[1, 2, 3, 4, 5].map(s => (
      <button key={s} type="button" onClick={() => onChange(s)}>
        <Star size={22}
          fill={s <= value ? '#f59e0b' : '#e5e7eb'}
          color={s <= value ? '#f59e0b' : '#e5e7eb'}
        />
      </button>
    ))}
  </div>
);